export const plumberBody = {
  name: "홍길동",
  statusCode: "11", // 기존에 사용하던 상태와 같은 값
  contact: "01052596324",
  itemCode: "P01532",
  address: "서울 강남구 역삼동 837-8",
  addressDetail: "102동 1903호",
  zipCode: "06253",
  workDate: "2024-03-12",
  totalPrice: 310000,
  memo: "고객님께서 하수구에서 냄새가 많이 난다고 하셨습니다.",
  options: [
    {
      id: "1",
      name: "배관케어",
      price: 160000,
    },
    {
      id: "2",
      name: "배관누수 탐지",
      price: 50000,
    },
    {
      id: "3",
      name: "하수구 악취 제거",
      price: 100000,
    },
  ],
};

export const mattressBody = {
  name: "홍길동",
  statusCode: "11", // 기존에 사용하던 상태와 같은 값
  contact: "01052596324",
  itemCode: "P01533",
  address: "서울 강남구 역삼동 837-8",
  addressDetail: "102동 1903호",
  zipCode: "06253",
  workDate: "2024-03-12",
  totalPrice: 320000,
  memo: "매트리스 하나는 폐기처분 요청",
  options: [
    {
      id: "2",
      name: "싱글 (1000*2000)",
      price: 30000,
    },
    {
      id: "3",
      name: "더블 (1400*2000)",
      price: 50000,
    },
    {
      id: "5",
      name: "라지킹 (1700*2000)",
      price: 100000,
    },
    {
      id: "8",
      name: "기타",
      price: 20000,
    },
  ],
};

const serverData = {
  columns: [
    { key: "receivedDate", header: "접수일" },
    { key: "name", header: "고객명" },
    { key: "contact", header: "연락처" },
    { key: "workDate", header: "작업일" },
    { key: "address", header: "작업주소", rowAlign: "left" },
    { key: "status", header: "상태", type: "badge" },
  ],
  rows: [
    {
      receivedDate: "2025-07-01",
      name: "이성훈",
      contact: "010-1234-5678",
      workDate: "2025-07-24",
      address: "서울특별시 송파구 문정로5길 2-26,101호",
      status: "11",
    },
    {
      receivedDate: "2025-07-02",
      name: "최유정",
      contact: "010-1234-5678",
      workDate: "2025-07-24",
      address: "서울특별시 송파구 문정로5길 2-26,101호",
      status: "11",
    },
    {
      receivedDate: "2025-04-01",
      name: "홍길동",
      contact: "010-1234-5678",
      workDate: "2025-07-24",
      address: "서울특별시 송파구 문정로5길 2-26,101호",
      status: "12",
    },
    {
      receivedDate: "2025-07-02",
      name: "이병만",
      contact: "010-4413-5678",
      workDate: "2025-07-24",
      address: "경기도 성남시 판교대로 32길",
      status: "13",
    },
    {
      receivedDate: "2025-04-01",
      name: "홍길동",
      contact: "010-1234-5678",
      workDate: "2025-07-24",
      address: "서울특별시 송파구 문정로5길 2-26,101호",
      status: "12",
    },
    {
      receivedDate: "2025-04-01",
      name: "홍길동",
      contact: "010-1234-5678",
      workDate: "2025-07-24",
      address:
        "서울특별시 송파구 문정로5길 2-26,101호 송파구 문정로5길 2-26,101호 송파구 문정로5길 2-26,101호",
      status: "11",
    },
  ],
};

export const mattressOptionList = [
  { name: "유아용", size: "500*1000" },
  { name: "싱글", size: "1000*2000" },
  { name: "슈퍼싱글", size: "1100*2000" },
  { name: "더블", size: "1400*2000" },
  { name: "퀸", size: "1500*2000" },
  { name: "킹", size: "1600*2000" },
  { name: "라지킹", size: "1700*2000" },
  { name: "라지킹 초과", size: "1800이상*2000이상" },
  { name: "옆면 습식 추가", size: "" },
  { name: "후면 습식 추가", size: "" },
  { name: "계단 이용", size: "" },
  { name: "기타", size: "" },
];

export const plumberOptionList = [
  { name: "배관케어", size: "" },
  { name: "배관해빙", size: "" },
  { name: "변기막힘", size: "" },
  { name: "싱크대", size: "" },
  { name: "배관누수 탐지", size: "" },
  { name: "하수구 악취 제거", size: "" },
  { name: "기타", size: "" },
];

export interface PlumberOptionItem {
  name: string;
  price: number;
}

export interface PlumberFormData {
  name: string;
  status: string;
  contact: string;
  itemCode: string;
  address: string;
  addressDetail: string;
  zipCode: string;
  workDate: string;
  totalPrice: number;
  memo: string;
  options: PlumberOptionItem[];
}
